import React from 'react';

// Decorative 24×24 line icons (stroke = currentColor). Always aria-hidden: the text next to an icon
// carries the meaning.
const PATHS = {
  lock: (
    <>
      <rect x="5" y="11" width="14" height="10" rx="2.5" />
      <path d="M8 11V7.5a4 4 0 0 1 8 0V11" />
      <path d="M12 15v2" />
    </>
  ),
  calendar: (
    <>
      <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
      <path d="M8 3v4M16 3v4M3.5 10h17" />
      <path d="M8 14h2M14 14h2M8 17h2" />
    </>
  ),
  'apps-check': (
    <>
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.8" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.8" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.8" />
      <path d="M14 17.5l2.2 2.2 4.3-4.4" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s-6.5-5.8-6.5-11a6.5 6.5 0 0 1 13 0c0 5.2-6.5 11-6.5 11z" />
      <circle cx="12" cy="10" r="2.4" />
    </>
  ),
  phone: (
    <path d="M6.6 3.5h2.8l1.6 4.2-2 1.4a10.5 10.5 0 0 0 5.9 5.9l1.4-2 4.2 1.6v2.8a2 2 0 0 1-2.1 2A16.5 16.5 0 0 1 4.6 5.6a2 2 0 0 1 2-2.1z" />
  ),
  chart: (
    <>
      <path d="M4 20h16" />
      <path d="M7 16.5v-4M12 16.5V7M17 16.5v-7" />
    </>
  ),
  widget: (
    <>
      <rect x="3.5" y="3.5" width="7.5" height="7.5" rx="2" />
      <rect x="13" y="3.5" width="7.5" height="7.5" rx="2" />
      <rect x="3.5" y="13" width="17" height="7.5" rx="2" />
    </>
  ),
  palette: (
    <>
      <path d="M12 3.5a8.5 8.5 0 1 0 0 17c1 0 1.7-.8 1.7-1.7 0-.5-.2-.9-.5-1.2-.3-.3-.5-.7-.5-1.2 0-1 .8-1.7 1.7-1.7h2a4.1 4.1 0 0 0 4.1-4.1C20.5 6.9 16.7 3.5 12 3.5z" />
      <circle cx="7.8" cy="11.5" r="1" />
      <circle cx="10" cy="7.6" r="1" />
      <circle cx="14.5" cy="7.6" r="1" />
    </>
  ),
  restart: (
    <>
      <path d="M4 12a8 8 0 1 0 2.6-5.9L4 8.5" />
      <path d="M4 4v4.5h4.5" />
    </>
  ),
  shield: <path d="M12 3l7.5 2.8v5.7c0 4.7-3.2 7.9-7.5 9.5-4.3-1.6-7.5-4.8-7.5-9.5V5.8L12 3z" />,
  'shield-lock': (
    <>
      <path d="M12 3l7.5 2.8v5.7c0 4.7-3.2 7.9-7.5 9.5-4.3-1.6-7.5-4.8-7.5-9.5V5.8L12 3z" />
      <rect x="9" y="11" width="6" height="4.8" rx="1.2" />
      <path d="M10.3 11V9.6a1.7 1.7 0 0 1 3.4 0V11" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.5 12h17" />
      <path d="M12 3.5c2.3 2.4 3.5 5.2 3.5 8.5s-1.2 6.1-3.5 8.5c-2.3-2.4-3.5-5.2-3.5-8.5s1.2-6.1 3.5-8.5z" />
    </>
  ),
  breath: (
    <>
      <path d="M3.5 9h9.5a2.8 2.8 0 1 0-2.8-2.8" />
      <path d="M3.5 13h14a2.8 2.8 0 1 1-2.8 2.8" />
      <path d="M3.5 17h6" />
    </>
  ),
  hand: (
    <>
      <path d="M8.5 12.5V5.8a1.5 1.5 0 0 1 3 0v5.7" />
      <path d="M11.5 11V4.5a1.5 1.5 0 0 1 3 0V11" />
      <path d="M14.5 11V6.3a1.5 1.5 0 0 1 3 0v7.2c0 4-2.7 7-6.6 7-2.5 0-4-1-5.3-2.8l-2.3-3.3a1.5 1.5 0 0 1 2.4-1.8l1.3 1.6" />
      <path d="M8.5 12.5V8.3a1.5 1.5 0 0 0-3 0v5.4" />
    </>
  ),
  heatmap: (
    <>
      <rect x="3.5" y="3.5" width="4.5" height="4.5" rx="1" />
      <rect x="9.75" y="3.5" width="4.5" height="4.5" rx="1" />
      <rect x="16" y="3.5" width="4.5" height="4.5" rx="1" fill="currentColor" />
      <rect x="3.5" y="9.75" width="4.5" height="4.5" rx="1" fill="currentColor" />
      <rect x="9.75" y="9.75" width="4.5" height="4.5" rx="1" />
      <rect x="16" y="9.75" width="4.5" height="4.5" rx="1" />
      <rect x="3.5" y="16" width="4.5" height="4.5" rx="1" />
      <rect x="9.75" y="16" width="4.5" height="4.5" rx="1" fill="currentColor" />
      <rect x="16" y="16" width="4.5" height="4.5" rx="1" />
    </>
  ),
  bell: (
    <>
      <path d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 1.5h-15L6 16.5z" />
      <path d="M10 20.5a2.2 2.2 0 0 0 4 0" />
    </>
  ),
  check: <path d="M5 12.5l4.5 4.5L19 7.5" />,
  dash: <path d="M7 12h10" />,
  'arrow-right': <path d="M5 12h14M13 6l6 6-6 6" />,
  info: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 11v5.5" />
      <path d="M12 7.6v.2" />
    </>
  ),
};

const MkIcon = ({ name, size = 24, className }) => (
  <svg
    className={className ? `mk-icon ${className}` : 'mk-icon'}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {PATHS[name] || null}
  </svg>
);

export default MkIcon;
